import { startsWith } from 'lodash';

const ATTRIBUTE_PREFIX = 'ATTRIBUTE_';

export const AttributeUniqueError = `${ATTRIBUTE_PREFIX}UNIQUE_ERROR`;
export const InternalServerError = 'INTERNAL_SERVER_ERROR';
export const FORBIDDEN = 403;

export const isAttributeErrorCode = (code) => startsWith(code, ATTRIBUTE_PREFIX);
